'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by zfc on 2017/6/29.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _workstationList = require('redux/modules/workstationList');

var workstationListActions = _interopRequireWildcard(_workstationList);

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WorkStationNewList = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store;
    var dispatch = _ref$store.dispatch;
    var getState = _ref$store.getState;
    var location = _ref.location;

    var promises = [];
    var query = location.query;
    var filter = '';
    var page = null;
    var orderItem = '';
    var direction = '';
    if (query.findValue) {
      filter = (0, _extends3.default)({}, filter, { FindValue: query.findValue });
    }
    if (query.province) {
      filter = (0, _extends3.default)({}, filter, { provinceId: query.province });
    }

    if (query.workstationType) {
      filter = (0, _extends3.default)({}, filter, { workstationType: query.workstationType });
    }
    if (query.page) {
      page = query.page;
    }
    if (query.orderItem) {
      orderItem = query.orderItem;
    }
    if (query.direction) {
      direction = query.direction;
    }
    promises.push(dispatch((0, _background.changeHeaderText)('区域')));
    promises.push(dispatch(workstationListActions.load(filter, {
      orderItem: orderItem,
      direction: direction
    }, workstationListActions.isLoaded(getState()), page)));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    data: state.workstationList.data
  };
}, (0, _extends3.default)({}, workstationListActions, {
  routerPush: _reactRouterRedux.push,
  routerReplace: _reactRouterRedux.replace
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WorkStationNewList, _Component);

  function WorkStationNewList() {
    (0, _classCallCheck3.default)(this, WorkStationNewList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(WorkStationNewList).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(WorkStationNewList, [{
    key: 'onPageItemClick',
    value: function onPageItemClick(page) {
      var _props = this.props;
      var routerPush = _props.routerPush;
      var location = _props.location;

      if (routerPush) {
        routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, location.query, { page: page }) });
        this.scrollToAnchor('homePageOrderBar');
      }
    }
  }, {
    key: 'onSearch',
    value: function onSearch(val) {
      var _props2 = this.props;
      var routerPush = _props2.routerPush;
      var location = _props2.location;

      if (routerPush) {
        var query = {};
        if (val) {
          query.findValue = val;
        }
        routerPush({ pathname: location.pathname, query: query });
      }
    }
  }, {
    key: 'onOrderItemClick',
    value: function onOrderItemClick(val) {
      var _props3 = this.props;
      var routerPush = _props3.routerPush;
      var location = _props3.location;

      switch (val) {
        case 'ALL':
          if (routerPush) {
            routerPush({ pathname: location.pathname, query: {} });
          }
          break;
        case 'xingzhengquyu':
          if (routerPush) {
            if (!location.query.workstationType || location.query.workstationType === '1') {
              routerPush({ pathname: location.pathname, query: { workstationType: '0' } });
            }
          }
          break;
        case 'tesequyu':
          if (routerPush) {
            if (!location.query.workstationType || location.query.workstationType === '0') {
              routerPush({ pathname: location.pathname, query: { workstationType: '1' } });
            }
          }
          break;
        default:
          if (routerPush) {
            var query = {};
            if (location.query.type) {
              query.type = location.query.type;
            }
            if (location.query.productType) {
              query.productType = location.query.productType;
            }
            if (location.query.shop) {
              query.shop = location.query.shop;
            }
            if (location.query.author) {
              query.author = location.query.author;
            }
            routerPush({ pathname: location.pathname, query: (0, _extends3.default)({}, query) });
          }
      }
    }
  }, {
    key: 'middleFilterItem',
    value: function middleFilterItem(val) {
      var _props4 = this.props;
      var routerPush = _props4.routerPush;
      var location = _props4.location;

      if (routerPush) {
        var query = {};
        if (val) {
          query.province = val;
        }
        routerPush({ pathname: location.pathname, query: query });
      }
    }
  }, {
    key: 'scrollToAnchor',
    value: function scrollToAnchor(anchorName) {
      if (anchorName) {
        var anchorElement = document.getElementById(anchorName);
        if (anchorElement) {
          anchorElement.scrollIntoView();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props;
      var data = _props5.data;
      var location = _props5.location;

      var currentPage = 0;
      var carouselDiv = '';
      var workStationInfoDiv = '';
      var middleFilterDiv = '';
      var totalPageNumber = 1;
      if (data) {
        // products, productsError
        var workstationList = data.workstationList;
        var workstationListError = data.workstationListError;
        var workstationListRecordCount = data.workstationListRecordCount;
        var workstationListPagesize = data.workstationListPagesize;
        var workstationListCarousal = data.workstationListCarousal;
        var workstationListCarousalError = data.workstationListCarousalError;
        var workstationMiddleFilterBar = data.workstationMiddleFilterBar;
        var workstationMiddleFilterBarError = data.workstationMiddleFilterBarError;

        if (workstationListCarousalError) {
          carouselDiv = '错误：' + workstationListCarousalError;
        } else if (workstationListCarousal instanceof Array) {
          carouselDiv = _react2.default.createElement(_components.GoeasyCarousel, { page: 'productList', images: workstationListCarousal });
        }

        if (workstationMiddleFilterBarError) {
          middleFilterDiv = '错误：' + workstationMiddleFilterBarError;
        } else if (workstationMiddleFilterBar instanceof Array) {
          middleFilterDiv = _react2.default.createElement(_components.WorkStationFilterBar, { data: workstationMiddleFilterBar, onItemClick: this.middleFilterItem.bind(this) });
        }

        if (workstationListError) {
          workStationInfoDiv = _react2.default.createElement(
            'li',
            { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
            workstationListError
          );
        } else {
          if (location.query && !isNaN(parseInt(location.query.page, 10))) {
            currentPage = parseInt(location.query.page, 10);
          }
          workStationInfoDiv = _react2.default.createElement(
            'ul',
            { style: { width: '100%' } },
            workstationList instanceof Array ? workstationList.map(function (workstation, index) {
              return _react2.default.createElement(_components.WorkStationInfo, { key: workstation.id, index: index, data: workstation });
            }) : _react2.default.createElement(
              'li',
              { style: { width: '100%', fontSize: 16, textAlign: 'center' } },
              '未搜索到相关工作站'
            )
          );
        }
        totalPageNumber = parseInt(workstationListRecordCount / workstationListPagesize, 10);
        if (workstationListRecordCount % workstationListPagesize > 0) {
          ++totalPageNumber;
        }
      }
      var orderArray = [{ id: 'ALL', text: '全部' }, { id: 'xingzhengquyu', text: '特色区域', quyuType: '0' }, { id: 'tesequyu', text: '行政区域', quyuType: '1' }, { id: 'zw', text: '' }, { id: 'zw', text: '' }, { id: 'zw', text: '' }];
      var middleImages = ['http://tupian.goeasy.cn:9999/yipinwang/third/gzz_icon_b.png', 'http://tupian.goeasy.cn:9999/yipinwang/third/gzz_icon_a.png'];
      return _react2.default.createElement(
        'div',
        null,
        carouselDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.HomePageSearchBar, { placeholderTexts: '请输入特色区域名称\\行政区域名称\\关键字', onSearch: this.onSearch.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        middleFilterDiv,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(_components.ListPageMiddleFlip, { data: middleImages }),
        _react2.default.createElement('a', { id: 'homePageOrderBar' }),
        _react2.default.createElement(_components.HomePageOrderBar, { texts: orderArray, location: location, onItemClick: this.onOrderItemClick.bind(this) }),
        _react2.default.createElement('div', { className: 'clear' }),
        /* 工作站瀑布页li */
        workStationInfoDiv,
        totalPageNumber && totalPageNumber > 1 ? _react2.default.createElement(_components.HomePagingBar, { selected: currentPage, totalPageNumber: totalPageNumber,
          onPageItemClick: this.onPageItemClick.bind(this) }) : '',
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return WorkStationNewList;
}(_react.Component), _class2.propTypes = {
  location: _react.PropTypes.object,
  params: _react.PropTypes.object,
  routerPush: _react.PropTypes.func,
  data: _react.PropTypes.object
}, _temp)) || _class) || _class);
exports.default = WorkStationNewList;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/WorkStationNewList/WorkStationNewList.js
 ** module id = 1552
 ** module chunks = 0
 **/